import { API } from '../api';
import { IFetchResourceTelemetryStatusParams, IResourceTelemetryStatus } from './interface';
import { VenStatus } from '../ven/interface';

export const fetchResourceTelemetryStatus = async (
    params: IFetchResourceTelemetryStatusParams,
    signal?: AbortSignal | null
): Promise<IResourceTelemetryStatus | null> => {
    const { resourceId, venId } = params;
    if (!resourceId || !venId) return null;

    const path = `/resource-telemetry-status?${new URLSearchParams({
        venId,
        resourceId,
    }).toString()}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot load resource telemetry status!`);
};

export const determineVenStatusFromTelemetry = (telemetry: IResourceTelemetryStatus | null, venEnabled: boolean): VenStatus | null => {
    if (telemetry) {
        return telemetry.oadr_online ? VenStatus.ONLINE : VenStatus.OFFLINE;
    }

    if (!venEnabled) {
        return VenStatus.DISABLED;
    }

    return VenStatus.OFFLINE;
};
